import { Map } from 'immutable'
import React from 'react'
import { AsyncState, Pair, Widget, jsxToWidget } from 'widgets-for-react'

import { loaderSVG } from '../../../public_site/utils/loader'
import { ImageSize, Url } from '../types.gen'

export function ImageContainer<extra_images>(
  url: AsyncState<Map<ImageSize<extra_images>, Url>>,
  imageSize: ImageSize<extra_images>,
  className: string,
  alt: string,
  get_default_data_src: () => ImageSize<extra_images>,
  get_default_data_srcset: () => Pair<ImageSize<extra_images>, string>[],
  proportions?: {
    width: string
    height: string
  }
): Widget<never> {
  return jsxToWidget(
    url.kind === 'loaded' ? (
      <img
        width={proportions?.width || undefined}
        height={proportions?.height || undefined}
        src={`${url.value.get(imageSize)}`} //ask tim to verify
        data-src={url.value.get(get_default_data_src())}
        data-srcset={get_default_data_srcset()
          .map(e => `${url.value.get(e.fst)} ${e.snd}`)
          .join(',')}
        data-sizes="auto"
        className={className}
        alt={alt || ''}
      />
    ) : url.kind === 'connection-error' ? (
      <>Error loading image</>
    ) : (
      <div className={`${className} ${className && className + '--loading'} svg-loader`}>{loaderSVG()}</div>
    )
  )
}
